import { timeZones1 } from "./timeZones1";
import { timeZones2 } from "./timeZones2";
import { timeZones3 } from "./timeZones3";

export const timeZones = [...timeZones1, ...timeZones2, ...timeZones3] as const;
